import styled from 'styled-components'
import { v1 as color } from 'sidecar-design-library'

export const ListLoginItem = styled.div`
  display: flex;
  border-bottom: solid 1px ${color.SILVER};
  margin-bottom: 0.625rem;
  padding: 0.625rem 0;
`

export const Info = styled.div`
  flex-basis: 50%;
`

export const Source = styled.div`
  flex-basis: 50%;
  flex-grow: 1;
  font-size: 1.125rem;
`

export const DataItem = styled.div`
  flex-basis: 100%;
  flex-grow: 1;
  color: ${color.GREY};
  font-size: 1.0625rem;
  padding: 0.125rem 0;
`

export const Elapsed = styled.div`
  flex-basis: 50%;
  flex-grow: 1;
  text-align: right;
  font-size: 1.0625rem;
  color: ${color.GREY};
`
